import React from 'react';

const NavBar = ({ title, tabs, currentTab, onTabChange }) => {
    return (
        <nav style={{ backgroundColor: '#ffffff', borderBottom: '1px solid #e5e7eb', position: 'sticky', top: 0, zIndex: 100, boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px', display: 'flex', gap: '24px', height: '64px', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginRight: '20px', cursor: 'pointer' }} onClick={() => onTabChange(tabs[0].id)}>
                    <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#111827', letterSpacing: '-0.025em' }}>{title}</span>
                </div>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                    {tabs.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => onTabChange(tab.id)}
                            style={{
                                background: 'none',
                                border: 'none',
                                borderBottom: currentTab === tab.id ? '2px solid #111827' : '2px solid transparent',
                                padding: '20px 12px',
                                fontSize: '0.95rem',
                                fontWeight: currentTab === tab.id ? '600' : '500',
                                color: currentTab === tab.id ? '#111827' : '#4b5563',
                                cursor: 'pointer',
                                transition: 'all 0.2s',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>
        </nav>
    );
};

export default NavBar;